import { Dispatcher } from '../../backend/index'

export default Dispatcher(process.env.NODE_ENV === 'production', process.env.REACT_APP_LOG ?? false)